/**
 * Returns outer rect without rotation that completely wraps inside rotated inner rect
 * @param {{ top: Number, left: Number, width: Number, height: Number }} root
 * @param {Number} angle
 * @returns {{
 *     top: Number,
 *     left: Number,
 *     width: Number,
 *     height: Number,
 *     bottom: Number,
 *     right: Number
 * }}
 */
const getOuterBBox = (root, angle = 0) => {
    const rad = angle * Math.PI/180;
    const cos = Math.abs(Math.cos(rad));
    const sin = Math.abs(Math.sin(rad));
    const width = cos * root.width + sin * root.height;
    const height = cos * root.height + sin * root.width;
    const left = root.left - (width - root.width) / 2;
    const top = root.top - (height - root.height) / 2;
    return {
        top,
        left,
        width,
        height,
        right: left + width,
        bottom: top + height
    };
};

module.exports = getOuterBBox;
